<div *ngFor="let alert of alerts" class="alert-wrapper container mt-3">
  <div role="alert" [class]="cssClass(alert)">
    <span class="alert-icon" [attr.aria-hidden]="true">
      <i class="fa {{ iconFor(alert) }}" aria-hidden="true"></i>
    </span>
    <div class="alert-body">
      <p class="alert-message mb-0" [innerHTML]="alert.message"></p>
    </div>
    <button type="button" class="alert-close" (click)="removeAlert(alert)" aria-label="Close">
      &times;
    </button>
  </div>
</div>